import React, { useEffect, useState } from 'react'
import Typography from '../Typography'
import { useTranslation } from '../../utils/localization'
import { ArrowUpTrayIcon } from '@heroicons/react/24/outline'

const CtaSection = () => {
  const t = useTranslation()
  
  return (
    <a href="/translate">
      <div 
        className="relative w-full h-[120px] sm:h-[180px] md:h-[260px] flex flex-col items-center justify-center pb-0"
      >
        <div 
          className="w-full flex flex-col items-center justify-center gap-4 md:gap-6 uppercase font-bold text-[12px] sm:text-base sm:text-lg md:text-xl lg:text-2xl text-center"
          style={{ zIndex: 10 }}
        >
          <Typography
            className="text-white"
          >
            {t`Translate Your File Now!`}
          </Typography>

          <div 
            className="w-10 sm:w-14 md:w-16 h-10 sm:h-14 md:h-16 flex items-center justify-center border-2 border-dashed border-white rounded-lg"
          >
            <ArrowUpTrayIcon className="w-6 sm:w-10 md:w-12 h-6 sm:h-10 md:h-12 text-white" />
          </div>
        </div>

        <div 
          className="absolute center w-full h-[120px] sm:h-[180px] md:h-[260px]"
        >
          <img src="/static/images/cta-background.webp" 
            className="absolute center w-full h-full object-cover" 
          />
        </div>
      </div>
    </a>
  )
}

export default CtaSection
